/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Intro_PInputs */

const es_faq_intro_p = /** @type {(inputs: Faq_Intro_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarpar ofrece dos modalidades para aprovechar tu barco y generar ingresos`)
};

const gl_faq_intro_p = /** @type {(inputs: Faq_Intro_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarpar ofrece dúas modalidades para aproveitar o teu barco e xerar ingresos`)
};

const en_faq_intro_p = /** @type {(inputs: Faq_Intro_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarpar offers two ways to use your boat and earn income`)
};

/**
* | output |
* | --- |
* | "Zarpar offers two ways to use your boat and earn income" |
*
* @param {Faq_Intro_PInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const faq_intro_p = /** @type {((inputs?: Faq_Intro_PInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Intro_PInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_faq_intro_p(inputs)
	if (locale === "en") return en_faq_intro_p(inputs)
	return es_faq_intro_p(inputs)
});